import { CARVE_TABLE_CONFIG } from 'features/deals/DealStages/EventActionCards/CarveDiffTable';
import { CarveSummary } from 'features/deals/DealStages/EventActionCards/CarveDiffTable/__generated__/CarveSummary';
import {
  CarveDetailsContainer,
  CarveDetailsLabel,
  CarveDetailsRow,
  CarveDetailsValue,
  CarveName,
  CarveNameRow,
} from 'ui-kit';

type Props = {
  baseSummary: CarveSummary;
  carveSummary?: CarveSummary | null;
};

const renderSummaryBlock = (
  summary: CarveSummary,
  label: string,
  keys: (keyof typeof CARVE_TABLE_CONFIG)[],
) => (
  <CarveDetailsContainer>
    <CarveNameRow>
      <CarveDetailsLabel>{''}</CarveDetailsLabel>
      <CarveName className="w-[180px]">{label}</CarveName>
    </CarveNameRow>
    {keys.map((key, index) => {
      const config = CARVE_TABLE_CONFIG[key];
      const value = summary[key];
      return (
        <CarveDetailsRow key={`${label}-${index}`}>
          <CarveDetailsLabel>{config.string}</CarveDetailsLabel>
          <CarveDetailsValue className="w-[180px]">{config.display(value)}</CarveDetailsValue>
        </CarveDetailsRow>
      );
    })}
  </CarveDetailsContainer>
);

const CarveComparisonTable = ({ baseSummary, carveSummary }: Props) => {
  const hasCarve = carveSummary && baseSummary.loan_count !== carveSummary.loan_count;
  const orderedKeys = Object.keys(CARVE_TABLE_CONFIG) as (keyof typeof CARVE_TABLE_CONFIG)[];

  return (
    <div className="flex gap-4">
      {renderSummaryBlock(baseSummary, 'Base', orderedKeys)}
      {hasCarve && renderSummaryBlock(carveSummary, 'Carve', orderedKeys)}
    </div>
  );
};

export default CarveComparisonTable;
